import { z } from 'zod';
export const shippingClaimSourceUnion = z.union([
    z.literal('Customer_App'),
    z.literal('Merchant_App'),
    z.literal('Retool'),
    z.literal('Gorgias_Ticket_Widget'),
    z.literal('Zowie_Inbox_Integration'),
    z.literal('Gladly_Hero_Integration'),
]);
//# sourceMappingURL=claimSource.js.map